import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { Tool, ToolSlot } from '../framework/Tool';
import { SurfaceDef } from '../model/SurfaceDef';
import { PickBreaklineInputTask } from './PickBreaklineInputTask';

export class DeleteBreaklineTool extends Tool {
  private readonly mapView: MapView;
  private readonly surfaceDef: SurfaceDef;
  private task: PickBreaklineInputTask;
  private breaklinesLayer: GraphicsLayer;

  constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, breaklinesLayer: GraphicsLayer) {
    super('Delete Breakline', 'single', toolSlot);
    this.mapView = mapView;
    this.surfaceDef = surfaceDef;
    this.task = new PickBreaklineInputTask(this.mapView, this.surfaceDef);
    this.breaklinesLayer = breaklinesLayer;
  }

  protected async onExecuteOperation(): Promise<void> {
    const result = await this.task.executeTaskAsync();

    this.surfaceDef.breaklinesSyncSet.deleteItem(result, false, true);
    //console.log('Delete breaklines1: ', this.surfaceDef.breaklinesSyncSet.getItems());
    //redraw layer
    this.breaklinesLayer.removeAll();
    for (const breakline of this.surfaceDef.breaklinesSyncSet.getItems()) {
      const graphic = breakline.generateGraphic(this.mapView.spatialReference);
      this.breaklinesLayer.add(graphic);
    }

    return;
  }

  protected async onCancelOperation(): Promise<void> {
    if (this.task.isExecuting) {
      await this.task.cancelTaskAsync();
    }
    return;
  }
}
